import { Injectable } from '@angular/core';
import {ReservationList, Reservation} from '../models/reservation.model';
import { DBService } from './db.service';

import { STORAGE_MY_RESERVATIONS } from '../../environments/constant';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class ReservationService {

  constructor(private db:DBService, private util:UtilService) { }


  requestReservation(reservation:Reservation){
    if(!this.db.reservationList[this.db.currentReservationListKey]) this.db.reservationList[this.db.currentReservationListKey] = new ReservationList(this.db.currentReservationListKey)
    if(!this.db.reservationList[this.db.currentReservationListKey].reservations) this.db.reservationList[this.db.currentReservationListKey].reservations = []
    reservation.parentID = this.db.currentReservationListKey
    this.db.reservationList[this.db.currentReservationListKey].reservations.push(reservation)
   // reservation.id = this.db.reservationList[this.db.currentReservationListKey].reservations.indexOf(reservation)
   // this.db.reservationList[this.db.currentReservationListKey].reservations[reservation.id] = reservation
    this.db.updateReservationList(this.db.currentReservationListKey)

    // *** Local Clients ***
    this.db.myPrivateReservations.push(reservation)
    localStorage.setItem(STORAGE_MY_RESERVATIONS, JSON.stringify(this.db.myPrivateReservations));
    this.db.subscribeForLocalReservations(reservation)

  }
}
